var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5305,
    cy: 21.5421,
    r: 20.8653,
    fill: "#2678F2",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 12.3595L22.1695 12.4305L19.2281 19.2567H16.3374C15.6477 19.2567 14.9884 19.3987 14.39 19.6522L16.165 15.4125L16.2055 15.3111L16.2765 15.1488C16.2968 15.088 16.3171 15.0271 16.3475 14.9764C17.6762 11.9031 19.1774 11.2032 22.2 12.3595Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6669 19.4594C27.2105 19.3174 26.7236 19.2565 26.2367 19.2565H19.228L22.1695 12.4304L22.1999 12.3594C22.352 12.4101 22.494 12.4811 22.6462 12.5419L24.8877 13.4852C26.1353 14.0025 27.0076 14.5401 27.535 15.1892C27.6365 15.3109 27.7176 15.4225 27.7886 15.5544C27.8799 15.6964 27.9509 15.8384 27.9915 15.9905C28.032 16.0818 28.0625 16.1731 28.0827 16.2542C28.3566 17.1062 28.1943 18.1509 27.6669 19.4594Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1886 24.2056V26.1834C31.1886 26.3863 31.1785 26.5891 31.1683 26.792C30.9756 30.3319 28.9978 32.117 25.2449 32.117H17.3335C17.09 32.117 16.8466 32.0967 16.6133 32.0663C13.3879 31.8533 11.6636 30.129 11.4506 26.9036C11.4202 26.6703 11.3999 26.4269 11.3999 26.1834V24.2056C11.3999 22.1669 12.6373 20.4121 14.4022 19.6514C15.0108 19.3979 15.6599 19.2559 16.3496 19.2559H26.249C26.746 19.2559 27.2329 19.3269 27.6792 19.4587C29.6976 20.0774 31.1886 21.964 31.1886 24.2056Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.165 15.4121L14.39 19.6518C13.4995 20.0349 12.7408 20.6703 12.2072 21.4796C11.6737 22.2888 11.3888 23.2366 11.3877 24.206V21.2341C11.3877 18.3535 13.4366 15.9497 16.165 15.4121ZM31.1855 21.2341V24.206C31.1855 21.9745 29.7047 20.0778 27.6761 19.4693C28.2035 18.1507 28.3557 17.1161 28.1021 16.254C28.0818 16.1627 28.0514 16.0714 28.0108 15.9903C29.8974 16.964 31.1855 18.9621 31.1855 21.2341Z",
    stroke: "#2678F2",
    strokeWidth: 1.30408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexIcon);
export default __webpack_public_path__ + "static/media/flexIcon.328e625cbe08d9911265020ca2cd22a9.svg";
export { ForwardRef as ReactComponent };